export default {
  header: {
    about: 'Über uns',
    services: 'Dienstleistungen',
    projects: 'Projekte',
    contact: 'Kontakt',
    impact: 'Wirkung',
  },
  about: {
    eyebrow: 'Über BlueAlps',
    hero_title_line1: 'Über',
    hero_title_line2: 'uns',
    hero_title:
      'Schweizerisch-brasilianische Technologie für Unternehmen, die sich weiterentwickeln wollen.',
    hero_tagline:
      'Nachhaltige Technologie, um Ungleichheiten zu reduzieren und einen positiven Impact zu schaffen. ',
    hero_lead:
      'BlueAlps ist ein schweizerisch-brasilianisches Technologieunternehmen, das auf individuelle Softwareentwicklung, künstliche Intelligenz, Automatisierung und digitale Transformation für Unternehmen spezialisiert ist. ',
    cta_services: 'Unsere Services entdecken',
    cta_contact: 'Kontakt aufnehmen',
    story_label: 'Unsere Geschichte',
    story_title:
      'Von schweizerisch-brasilianischen Wurzeln zu einem multikulturellen Team.',
    story_title_part1: 'Eine Geschichte, geprägt von ',
    story_title_part2: ' Vision und Menschen ',
    story_paragraphs: [
      'BlueAlps entstand aus dem Traum, durch Technologie Chancen zu schaffen und positive Wirkung zu erzielen. ',
      'Was mit einer Vision und einem ersten Entwickler begann, entwickelte sich zu einem internationalen Team. ',
    ],
    story_highlight:
      'Heute vertrauen <strong>Unternehmen</strong> auf unsere Kompetenz bei der Entwicklung innovativer und nachhaltiger Lösungen. ',
    story_stat_countries: '<strong>2 Länder</strong> verbunden',
    story_stat_solutions: '<strong>Individuelle</strong> Lösungen',
    client_map_title: 'Unsere wichtigsten Kunden',
    client_map_country: 'Schweiz',
    story_quote:
      'Unser wichtigstes Differenzierungsmerkmal ist <strong>Schweizer Qualität</strong> zu <strong>einem der wettbewerbsfähigsten Preise am Markt</strong>. Wir verbinden brasilianische Kreativität, Schweizer Präzision und effiziente Abläufe, um leistungsstarke Lösungen zu attraktiven Preisen anzubieten. ',
    story_steps: [
      {
        title: 'Der Traum',
        text: 'Technologie, um Chancen und positive Wirkung zu schaffen.',
      },
      {
        title: 'Der erste Schritt',
        text: 'Eine Vision wurde mit dem ersten Entwickler lebendig.',
      },
      {
        title: 'Das Team wuchs',
        text: 'Neue Talente und Perspektiven wurden Teil der Reise.',
      },
      {
        title: 'Das Vertrauen kam',
        text: 'Mehr als 5 Unternehmen begannen, uns zu vertrauen.',
      },
      {
        title: 'Wir fangen gerade erst an',
        text: 'Wir wachsen weiter zwischen Brasilien und der Schweiz.',
      },
    ],
    faq: {
      label: 'FAQ',
      title: 'Häufig gestellte Fragen',
      subtitle:
        'Direkte Antworten darauf, wie wir arbeiten, was uns auszeichnet und was Sie von jedem Projekt mit BlueAlps erwarten können. ',
      items: [
        {
          question:
            'Was ist das wichtigste Differenzierungsmerkmal von BlueAlps?',
          answer:
            'Wir verbinden Schweizer Qualität, brasilianische Kreativität und effiziente Abläufe, um leistungsstarke Softwarelösungen zu wettbewerbsfähigen Preisen anzubieten. ',
        },
        {
          question: 'Arbeitet BlueAlps mit Unternehmen ausserhalb der Schweiz?',
          answer:
            'Ja. Wir arbeiten mit Unternehmen in der Schweiz, in Brasilien und weiteren Ländern zusammen – mit klarer Kommunikation, effizienten Prozessen und einer reibungslosen Remote-Zusammenarbeit. ',
        },
        {
          question: 'Welche Lösungen entwickelt ihr?',
          answer:
            'Wir entwickeln individuelle Software, Automatisierungen, KI-Lösungen, Integrationen, Websites, interne Systeme und Projekte zur digitalen Transformation.',
        },
        {
          question: 'Wie startet ein Projekt?',
          answer:
            'Jedes Projekt beginnt damit, die Ziele, die aktuelle Situation und die Prioritäten unserer Kunden zu verstehen. Anschliessend definieren wir den Projektumfang, den Zeitplan und die nächsten Schritte transparent. ',
        },
      ],
    },
    feedback: {
      label: 'Kundenfeedback',
      title: 'Was unsere Kunden sagen',
      subtitle:
        'Partnerschaften mit Klarheit, Verantwortung und Fokus auf verlässliche digitale Ergebnisse.',
      items: [
        {
          quote:
            'Wir sind mit der Zusammenarbeit sehr zufrieden. Das junge, motivierte Team arbeitet unkompliziert, lösungsorientiert und mit viel Engagement. Unsere Anliegen wurden stets ernst genommen und schnell umgesetzt – genau so stellt man sich eine erfolgreiche Partnerschaft vor.',
          name: 'Cornelia',
          company: 'Divina Textil AG',
          companyUrl: 'https://www.divina.ch/de',
        },
        {
          quote:
            'Die Zusammenarbeit war sehr angenehm. Als ich Laryssa kennenlernte, hat mich das sehr beruhigt, da die Kommunikation auf Deutsch dadurch viel einfacher und persönlicher wurde. Besonders geschätzt habe ich die schnellen Rückmeldungen, die Geduld und die Unterstützung des Teams, auch nachdem die Homepage bereits online war.',
          name: 'Erika',
          company: 'Projekt Müller',
          companyUrl: 'https://mueller-handarbeiten.ch/',
        },
        {
          quote:
            'Die Zusammenarbeit mit Igor bei der Weiterentwicklung von HausHeld.ch, Aufzugo und weiteren Projekten war stets sehr professionell und zuverlässig. Besonders schätzen wir seine hohe Qualität, seine schnelle Umsetzung von Feedback sowie seine lösungsorientierte Arbeitsweise. Igor ist ein geschätzter Partner, den wir jederzeit weiterempfehlen können.',
          name: 'Alessandro Affentranger',
          company: 'Leiter Entwicklung - Vermando AG',
          companyUrl: 'https://www.vermando.com/',
        },
      ],
    },
    website_carousel: {
      label: 'Unsere Website',
      title: 'Mehr über BlueAlps erfahren. ',
      subtitle:
        'Jeder Bereich der Website zeigt, wie wir Technologie, Wirkung und Partnerschaft verbinden.',
      items: [
        {
          title: 'Services',
          description:
            'Entdecken Sie unsere Lösungen in Software, künstlicher Intelligenz, Automatisierung, technischem SEO, UX, PIM, WordPress und Cybersicherheit.',
        },
        {
          title: 'Wirkung',
          description:
            'Erfahren Sie, wie wir Technologie und gesellschaftliche Verantwortung verbinden, um Ergebnisse für eine nachhaltigere Zukunft zu schaffen.',
        },
        {
          title: 'Projekte',
          description:
            'Sehen Sie Beispiele digitaler Projekte und Initiativen, die unsere technische Kompetenz in der Praxis zeigen. ',
        },
        {
          title: 'Kontakt',
          description:
            'Sprechen Sie mit dem BlueAlps-Team, um Ihr Projekt zu besprechen, ein individuelles Angebot anzufordern oder eine Zusammenarbeit zu beginnen. ',
        },
        {
          title: 'Werte',
          description:
            'Lernen Sie die Prinzipien kennen, die unsere Entscheidungen, unsere Kultur und vertrauensvolle Beziehungen leiten.',
        },
      ],
    },
    team: {
      label: 'BlueAlps Team',
      title: 'Die Menschen hinter der Technologie',
      subtitle:
        'Ein multikulturelles Team, das Strategie, Engineering und Umsetzung verbindet, um Ideen in digitale Lösungen zu verwandeln.',
      linkedin_label: '{{name}} auf LinkedIn ansehen',
      members: [
        {
          name: 'Daniel Hefti',
          role: 'Chief Executive Officer',
          description:
            'Leitet die strategische Vision von BlueAlps und verbindet den Schweizer Markt mit hochwertigen digitalen Lösungen und Wirkung.',
        },
        {
          name: 'Igor Araújo',
          role: 'IT Manager & Full-Stack Developer',
          description:
            'Hilft Unternehmen, individuelle Funktionen zu entwickeln, technisches SEO zu verbessern, APIs zu verbinden und die Cybersicherheit digitaler Plattformen zu stärken.',
        },
        {
          name: 'Maria Victória',
          role: 'IT Manager & Frontend Developer',
          description:
            'Verbindet IT-Management, E-Commerce, UX, Google-Tools und Design, um Ideen in klare und funktionale digitale Erlebnisse zu verwandeln.',
        },
        {
          name: 'Matheus Luiz',
          role: 'Backend Developer & DevOps',
          description:
            'Fokussiert sich auf Backend, KI, Automatisierungen und Integrationen für E-Commerce und PIM Core und schafft intelligente Abläufe für Daten, Produkte und Prozesse.',
        },
        {
          name: 'Laryssa Sams',
          role: 'Customer Relations',
          description:
            'Unterstützt die Kommunikation mit Kunden und Partnern und sorgt für Klarheit, Begleitung und Sorgfalt in jeder Phase.',
        },
      ],
    },
    mission_title: 'Mission',
    mission_text:
      'Wir unterstützen Unternehmen mit zugänglichen, leistungsstarken und wirkungsorientierten Softwarelösungen, die technisches Know-how, Geschäftsverständnis und gesellschaftliche Verantwortung verbinden.',
    vision_title: 'Vision',
    vision_text:
      'Wir fördern eine gerechtere, inklusivere und nachhaltigere Zukunft durch gut entwickelte Technologie, internationale Zusammenarbeit und Innovation für reale Herausforderungen.',
    values_label: 'Unsere Werte',
    values_title: 'Unsere Werte',
    values_intro:
      'Unsere Werte sind die Grundlage unserer Identität und leiten alle unsere Entscheidungen. Sie prägen unsere Kultur, unsere Partnerschaften und die Wirkung, die wir erzielen möchten.',
    values: {
      equity: {
        title: 'Chancengleichheit',
        text: 'Wir fördern Chancengleichheit für alle Menschen und setzen uns für Fairness in Partnerschaften, Prozessen und im Arbeitsumfeld ein. ',
      },
      inclusion: {
        title: 'Inklusion & Vielfalt',
        text: 'Wir schaffen einladende Umgebungen und wertschätzen unterschiedliche Perspektiven, Kulturen, Herkünfte und Erfahrungen. ',
      },
      integrity: {
        title: 'Integrität',
        text: 'Wir handeln transparent, ethisch und verantwortungsvoll gegenüber unseren Kunden, Kolleginnen, Kollegen und der Gesellschaft. ',
      },
      collaboration: {
        title: 'Zusammenarbeit',
        text: 'Wir glauben an nachhaltiges Wachstum durch Zusammenarbeit, starke Partnerschaften und gemeinsame Ziele, die auf Vertrauen und Respekt basieren. ',
      },
      sustainability: {
        title: 'Nachhaltigkeit',
        text: 'Wir treffen Entscheidungen, die ökologische, soziale und wirtschaftliche Nachhaltigkeit fördern – mit Blick auf Gegenwart und Zukunft. ',
      },
    },
    final_cta: {
      title_line1: 'Lassen Sie uns Ihre digitale',
      title_line2: 'Vision Wirklichkeit werden lassen.',
      title_accent: 'Bereit für Ihr nächstes digitales Projekt?',
      contact_button: 'Kontakt aufnehmen',
    },
  },
  impact: {
    hero: {
      title_line1: 'Impact, der Ingenieurwesen verbindet,',
      title_line2: 'Nachhaltigkeit und echte Ergebnisse.',
      subtitle:
        'Bei BlueAlps verwandeln wir Visionen in messbare Wirkung durch agile, zugängliche und zweckorientierte Lösungen – im Einklang mit den Zielen der Vereinten Nationen für nachhaltige Entwicklung.',
      description:
        'Bei BlueAlps sind wir überzeugt, dass Technologie positive Wirkung entfalten kann. Deshalb richten wir unsere Strategien an den UN-SDGs aus. Wir arbeiten an einer nachhaltigen, fairen und chancenreichen Zukunft für alle. Begleiten Sie uns auf diesem Weg und entdecken Sie, wie unsere Softwarelösungen Ihr Unternehmen stärken und gleichzeitig langfristigen Impact erzeugen.',
      cta_primary: 'Unsere Projekte ansehen',
      cta_secondary: 'Unsere Services ansehen',
    },
    ods: {
      title: 'Impact im Einklang mit den Zielen für nachhaltige Entwicklung',
      subtitle:
        'Unsere Lösungen sind darauf ausgelegt, konkrete Ergebnisse zu liefern und gleichzeitig direkt zu den UN-SDGs beizutragen – mit Technologie, Verantwortung und messbarer Wirkung.',
      items: {
        ods3: {
          title: 'SDG 3 – Gesundheit und Wohlergehen',
          desc: 'Projekte, die Gesundheit, Sicherheit und Lebensqualität fördern und sichere, zuverlässige sowie zugängliche Systeme unterstützen.',
        },
        ods8: {
          title: 'SDG 8 – Menschenwürdige Arbeit und Wirtschaftswachstum',
          desc: 'Ingenieurlösungen, die Effizienz steigern, Verschwendung reduzieren und Teams mehr Zeit für wertschöpfende Arbeit geben.',
        },
        ods9: {
          title: 'SDG 9 – Industrie, Innovation und Infrastruktur',
          desc: 'Moderne, skalierbare und resiliente Architekturen zur Unterstützung des Wachstums zweckorientierter KMU – ohne technische Kompromisse.',
        },
        ods12: {
          title: 'SDG 12 – Nachhaltiger Konsum und Produktion',
          desc: 'Reduktion digitaler Verschwendung, optimierte Ressourcennutzung und datenbasierte Entscheidungen für Technologie,n.',
        },
        ods13: {
          title: 'SDG 13 – Klimaschutz',
          desc: 'Projekte mit Fokus auf Energieeffizienz, Monitoring und Reduzierung des CO2-Fussabdrucks digitaler Lösungen.',
        },
      },
    },
    how: {
      title: 'Impact von Menschen gemacht – und in der Praxis bewiesen.',
      subtitle:
        'Kein Marketing-Impact. Jede Lieferung entsteht aus realer Projektarbeit – mit Effizienz, Verantwortung und Zugänglichkeit.',
      badge: 'Team in Aktion ??',
    },
    steps: {
      step1: {
        title: 'Vom echten Problem zum funktionierenden Plan',
        desc: 'Wir analysieren den Kontext, definieren Metriken und priorisieren Massnahmen mit dem grössten Impact.',
      },
      step2: {
        title: 'Schlanke Lieferung in hoher Qualität',
        desc: 'Performance, Developer Experience und Wartbarkeit stehen im Fokus – skalierbar und nachhaltig.',
      },
      step3: {
        title: 'Messung statt Bauchgefühl',
        desc: 'Wir überwachen KPIs und validieren Ergebnisse: Kosten, Energie, Zuverlässigkeit, Barrierefreiheit und Nutzererlebnis.',
      },
      step4: {
        title: 'Kontinuierliche Partnerschaft',
        desc: 'Nachhaltige Wirkung entsteht durch langfristige Zusammenarbeit und stetige Verbesserung.',
      },
    },
    teamImpact: {
      title: 'Projekte unseres Teams mit realer Wirkung',
      subtitle:
        'Jede Karte zeigt, was umgesetzt wurde, von wem – und welchen Impact es erzeugt hat.',
    },
    projects: {
      impactLabel: 'Erzeugte Wirkung',
      items: {
        p1: {
          author: 'Maria – Frontend & QA',
          role: 'Plattform & Daten-UX (Mama Ativa)',
          title:
            'Mama Ativa: Mehr Spenden durch Gamification + datengetriebene Engpässe-Prognosen',
          summary:
            'Plattform zur Förderung von Muttermilchspenden mit gamifizierten Anreizen und Analytics, damit Spenderinnen sehen, wo Bedarf entsteht – und Teams Engpässe früh erkennen.',
          impact:
            'Ergebnis: bessere Verteilung von Spenden, schnellere Reaktion auf drohende Knappheit und mehr Transparenz für Spenderinnen und Management.',
          ods: 'SDG 3 – SDG 9 – SDG 12',
          tags: 'Data Analytics – Gamification – HealthTech',
        },
        p2: {
          author: 'Maria & Matheus – App & Backend',
          role: 'Safety App (Alerta Rosa)',
          title:
            'Alerta Rosa: Schneller Hilfezugang und sicherere Wege im Alltag',
          summary:
            'Sicherheits-App mit SOS-Alarm, schnellen Notfallkontakten und Standort-/Service-Infos, um Unterstützung in kritischen Situationen sofort erreichbar zu machen.',
          impact:
            'Ergebnis: kürzere Reaktionszeiten, klare Handlungswege im Notfall und mehr Sicherheit im Alltag – besonders in Stressmomenten.',
          ods: 'SDG 5 – SDG 11 – SDG 16',
          tags: 'Women Safety – SOS – Mobile App',
        },
      },
    },
    cta: {
      title: 'Lust auf nachhaltige Projekte mit messbarer Wirkung?',
      desc: 'Erzählen Sie uns von Ihrer Herausforderung. Wir liefern mit Exzellenz und belegen Wirkung mit Daten.',
      button: 'Mit BlueAlps sprechen',
    },
  },
  services: {
    hero_title: 'Spezialisten für digitale Ingenieurskunst mit echter Wirkung',
    hero_subtitle:
      'Wir stellen Spezialisten auf Abruf bereit, um Ihre Organisation zu stärken – von technischem SEO und PIM bis hin zu WordPress und Cybersicherheit, mit Fokus auf messbare Ergebnisse.',
    direct_contact_note: 'Wir kontaktieren Sie direkt aus Brasilien.',
    currency_selector_kicker: 'Preiswährung',
    currency_selector_title: 'Wählen Sie die Währung der angezeigten Preise',
    currency_selector_subtitle:
      'Die Karten und die Tabelle mit den kommerziellen Konditionen werden automatisch in die gewählte Währung umgerechnet.',
    currency_selector_aria_label: 'Preiswährung auswählen',
    currency_selector_options: {
      CHF: 'Schweizer Franken',
      USD: 'US-Dollar',
      EUR: 'Euro',
    },
    cta_request_specialist: 'Spezialisten anfordern',
    view_details: 'Details ansehen',
    back_to_services: 'Zurück zu Dienstleistungen',
    detail_what_is_title: 'Was bietet dieser Service?',
    detail_deliverables_title: 'Was Sie erwarten können',
    detail_value_title: 'Preis',
    detail_discount_note:
      'Bei Projekten mit höherem Budget sind je nach Umfang, Laufzeit und gebuchtem Volumen attraktive Rabatte möglich.',
    detail_schedule_cta: 'Termin buchen',
    detail_booking_strip_label: 'Kostenloser Termin',
    detail_booking_strip_title:
      'Sprechen Sie mit BlueAlps, bevor Sie sich entscheiden.',
    detail_booking_strip_text:
      'In einem kurzen Gespräch besprechen wir Ihre Ziele, beantworten Ihre Fragen und zeigen Ihnen den einfachsten Weg zum Start. ',
    detail_booking_reasons_label: 'Nächster Schritt',
    detail_booking_reasons_title:
      'Warum lohnt es sich, jetzt einen Termin zu buchen?',
    detail_booking_reasons_text:
      'Im Gespräch entwickeln wir aus Ihren Ideen einen klaren Plan mit Prioritäten, Umfang und konkreten nächsten Schritten. ',
    detail_booking_reason_1_title: 'Schnelle Einschätzung',
    detail_booking_reason_1_text:
      'Wir analysieren die aktuelle Situation und erkennen, wo dieser Service den grössten Mehrwert bieten kann. ',
    detail_booking_reason_2_title: 'Klarer Projektumfang',
    detail_booking_reason_2_text:
      'Sie erhalten Klarheit über den Lieferumfang, den Aufwand und das passende Modell für die Zusammenarbeit. ',
    detail_booking_reason_3_title: 'Kostenloses Erstgespräch',
    detail_booking_reason_3_text:
      'In einem unverbindlichen Gespräch finden wir gemeinsam heraus, ob eine Zusammenarbeit mit BlueAlps für Sie sinnvoll ist. ',
    detail_final_cta_label: 'Bereit für den nächsten Schritt?',
    detail_final_cta_title:
      'Buchen Sie einen Termin und bringen Sie Ihr Projekt voran.',
    detail_final_cta_text:
      'Wählen Sie einen passenden Termin über Microsoft Bookingss und besprechen Sie Ihr Projekt direkt mit unserem Team. ',
    detail_ideal_client_title: 'Für wen eignet sich dieser Service?',
    plan_price_from: 'Pro Stunde',
    plan_recommended_fast_impact: 'Schneller Impact',
    plan_recommended_specialty: 'Unsere Spezialitat',
    plan_ecommerce_title: 'E-Commerce',
    plan_ecommerce_desc:
      'Erstellung, Neugestaltung und Weiterentwicklung von Online-Shops mit strukturiertem Produktkatalog, zuverlässigem Checkout und passenden Integrationen – optimal auf Wachstum ausgerichtet. ',
    plan_ux_title: 'Layout- & UX-Optimierung',
    plan_ux_desc:
      'Verbesserung von visueller Hierarchie, Usability und Conversion durch gezielte Layout-Anpassungen und UX-Empfehlungen.',
    plan_tech_seo_title: 'Spezialisten für technisches SEO',
    plan_tech_seo_desc:
      'Verbessern Sie Crawling, Ladezeit und Indexierung mit technischem SEO - für messbares Wachstum.',
    plan_analytics_schema_title: 'Google Analytics & Schema',
    plan_analytics_schema_desc:
      'Einrichtung von Tracking, Events, Conversions und strukturierten Daten, um Ergebnisse besser zu verstehen und die Sichtbarkeit in Suchmaschinen zu verbessern. ',
    plan_pim_title: 'PIM-Spezialisten (Open Source)',
    plan_pim_note: ' Produktinformationsmanagement',
    plan_pim_desc:
      'Aufbau oder Integration eines Open-Source-PIM-Systems zur Zentralisierung von Produktdaten und Verbesserung der Datenqualität. ',
    plan_wordpress_title: 'WordPress-Spezialisten',
    plan_wordpress_desc:
      'Zuverlässige WordPress-Entwicklung mit Fokus auf Performance, Sicherheit und langfristige Wartbarkeit.',
    plan_cyber_title: 'Cybersicherheits-Spezialisten',
    plan_cyber_desc:
      'Stärken Sie Ihre IT-Sicherheit mit gezielter Systemhärtung, kontinuierlicher Überwachung und Vorbereitung auf Sicherheitsvorfälle. ',
    plan_digital_link_page_title: 'Digitale Linkseite',
    plan_digital_link_page_desc:
      'Personalisierte digitale Linkseite, die wichtige Links, Social-Media-Kanäle, Kontaktdaten und Angebote an einem Ort bündelt.',
    plan_individual_title: 'Individual',
    plan_business_title: 'Business',
    plan_business_recommended: 'Empfohlen',
    plan_custom_title: 'Custom (On-Demand)',
    plan_audit_title: 'Audit',
    plan_individual_desc:
      'Ideal für Einzelpersonen und kleine Unternehmen, die eine einfache und effiziente Online-Präsenz benötigen.',
    plan_business_desc:
      'Für wachsende Unternehmen mit Bedarf an mehr Seiten, Integrationen und dynamischen Inhalten.',
    plan_design_note: 'Responsives Design und Prototyping.',
    plan_custom_desc:
      'Massgeschneiderte, skalierbare Projekte – vollständig auf Ihre Bedürfnisse abgestimmt.',
    plan_audit_feature_privacy: 'Datenschutz- und Compliance-Bericht',
    plan_audit_feature_performance: 'Performance- und SEO-Analyse',
    plan_audit_feature_accessibility:
      'Überprüfung von Barrierefreiheit und Usability',
    plan_audit_feature_security: 'Sicherheits- und Risiko-Checkliste',
    plan_audit_desc:
      'Eine umfassende Prüfung von Datenschutz, Performance und Umweltauswirkungen – mit klaren, umsetzbaren Empfehlungen. ',
    ideal_clients: {
      ecommerce:
        'Für Unternehmen, die online verkaufen möchten und einen zuverlässigen, einfach zu verwaltenden Online-Shop benötigen, der Produkte, Zahlungen, Logistik und Marketing miteinander verbindet. ',
      tech_seo:
        'Für Unternehmen mit Website, Online-Shop oder digitaler Plattform, die ihre Sichtbarkeit in Suchmaschinen, Ladezeiten, Indexierung und technische SEO-Qualität verbessern möchten. ',
      analytics_schema:
        'Für Unternehmen, die Besuche, Events und Conversions zuverlässig messen und strukturierte Daten nutzen möchten, damit Suchmaschinen Seiten, Produkte, Dienstleistungen und Inhalte besser verstehen können. ',
      pim: 'Für Unternehmen mit vielen Produkten, verteilten Daten in Tabellen, ERP oder E-Commerce und Teams, die Produktinformationen zentral verwalten, die Datenqualität verbessern und Prozesse automatisieren möchten. ',
      wordpress:
        'Für Unternehmen, die WordPress bereits nutzen oder künftig einsetzen möchten und eine schnelle, sichere und einfach zu wartende Website benötigen, die mit ihrem Unternehmen wachsen kann. ',
      ux: 'Für Unternehmen mit niedriger Conversion, unklarer Navigation, veraltetem Layout oder Nutzern, die wichtige Aktionen nur schwer finden oder ausführen können. ',
      digital_link_page:
        'Für Fachpersonen, Marken und Unternehmen, die eine einfache, professionelle und übersichtliche Seite für Links, Social Media, Kontaktdaten und Angebote benötigen. ',
      cyber:
        'Für Organisationen mit sensiblen Daten, internen Zugriffen, Online-Systemen oder kritischen Websites, die ihre Sicherheitsrisiken gezielt reduzieren möchten. ',
      audit:
        'Für Unternehmen, die vor Investitionen in Verbesserungen schnell erkennen möchten, wo die wichtigsten Schwachstellen bei Datenschutz, Performance, SEO, Barrierefreiheit und Sicherheit liegen. ',
    },
    detail_outcomes_title: 'Erwartete Ergebnisse',
    detail_when_to_use_title: 'Wann ist dieser Service sinnvoll? ',
    detail_workflow_title: 'Unsere Projektesweise',
    detail_timeline_period: 'Schritt {{count}}',
    detail_timeline_keyword: 'HAUPTPHASE',
    detail_faq_title: 'Häufige Fragen zu diesem Service',
    service_details: {
      ecommerce: {
        overview:
          'Der E-Commerce-Service entwickelt und optimiert Online-Shops – mit Fokus auf einen gut strukturierten Produktkatalog, einen zuverlässigen Checkout, wichtige Integrationen und eine Lösung, die mit Ihrem Unternehmen wachsen kann. ',
        outcomes: [
          'Ein klar strukturierter, professioneller Online-Shop, der einfach zu verwalten ist. ',
          'Übersichtlicher Katalog mit klar aufgebauten Produktseiten und einem einfachen Kaufprozess.',
          'Integrationen für Zahlungen, Logistik, ERP, PIM oder Marketing-Tools.',
          'Eine solide technische Basis für Performance, SEO, Analyse und kontinuierliche Weiterentwicklung. ',
        ],
        when_to_use: [
          'Sie wollen einen neuen Online-Shop starten.',
          'Ihr aktueller Shop ist schwer zu verwalten, langsam oder unzuverlässig.',
          'Katalog, Checkout oder Integrationen bremsen das Wachstum.',
          'Sie möchten Ihren Online-Shop mit Produktdaten, ERP-Systemen oder Marketingkampagnen verbinden. ',
        ],
        workflow: [
          'Wir analysieren den Katalog, den Kaufprozess, die Integrationen und die geschäftlichen Anforderungen.',
          'Wir planen die passende Architektur, die Plattform, die Seitenstruktur, die Daten und den Checkout-Prozess.',
          'Wir entwickeln den Online-Shop mit Fokus auf Performance, Benutzerfreundlichkeit und einfache Verwaltung. ',
          'Wir testen den Kaufprozess, die Zahlungen und die Integrationen. Anschliessend erstellen wir eine klare Dokumentation für den Betrieb. ',
        ],
        workflow_titles: ['Analyse', 'Planung', 'Entwicklung', 'Übergabe'],
        faq: [
          {
            question: 'Erstellen Sie Online-Shops von Grund auf?',
            answer:
              'Ja. Wir erstellen neue Online-Shops oder bauen bestehende Shops neu auf – inklusive Plattform, Struktur, Katalog, Checkout und den benötigten Integrationen. ',
          },
          {
            question: 'Integrieren Sie ERP, PIM oder Zahlungsanbieter?',
            answer:
              'Ja. Wir integrieren ERP-, PIM- und Zahlungssysteme und sorgen für zuverlässige Verbindungen, die manuelle Arbeit reduzieren und Ihre Abläufe vereinfachen.',
          },
          {
            question: 'Wann ist ein PIM-System für E-Commerce sinnvoll?',
            answer:
              'Ein PIM-System ist besonders sinnvoll, wenn Ihr Shop viele Produkte, Varianten, Sprachen oder Vertriebskanäle umfasst. Es verwaltet Produktinformationen zentral und sorgt für einheitliche, aktuelle Daten in Ihrem Online-Shop. ',
          },
          {
            question: 'Ist der Online-Shop für SEO und Analytics vorbereitet?',
            answer:
              'Ja. Wir schaffen die technischen Grundlagen für SEO und Analytics, damit Ihr Shop gut auffindbar ist und wichtige Daten zuverlässig gemessen werden können. ',
          },
          {
            question: 'Welche Plattformen nutzen Sie für E-Commerce?',
            answer:
              'Das hängt vom jeweiligen Projekt ab. Wir berücksichtigen den Katalog, notwendige Integrationen, das Budget, die Anforderungen Ihres Teams und Ihre Wachstumspläne, bevor wir die passende Plattform empfehlen. ',
          },
          {
            question: 'Übernehmen Sie auch die Produktpflege?',
            answer:
              'Ja. Wir unterstützen Sie bei der ersten Einrichtung Ihrer Produkte – von Kategorien und Attributen bis hin zu Varianten und Bildern. Bei grösseren Katalogen empfehlen wir eine strukturierte Datenverwaltung mit einem PIM-System oder übersichtlichen Tabellen. ',
          },
          {
            question: 'Migrieren Sie bestehende Online-Shops?',
            answer:
              'Ja. Zuerst analysieren wir die bestehende Plattform, Produkte, URLs, Integrationen, Bestellungen, Kundendaten und mögliche SEO-Risiken. So planen wir die Migration mit möglichst geringen Auswirkungen auf den laufenden Betrieb. ',
          },
          {
            question:
              'Kann der Online-Shop verschiedene Zahlungs- und Versandoptionen anbieten?',
            answer:
              'Ja. Wir können verschiedene Zahlungsarten, Versandregeln, Lieferberechnungen und Logistiklösungen integrieren – abhängig von der technischen Verfügbarkeit der jeweiligen Plattform und Anbieter.',
          },
          {
            question:
              'Optimieren Sie auch Online-Shops, die bereits Live sind? ',
            answer:
              'Ja. Wir optimieren Performance, Produktseiten, Checkout, Analytics-Events, technisches SEO sowie Integrationen und reduzieren Schwachstellen im Kaufprozess. ',
          },
          {
            question:
              'Kann ich den Online-Shop nach der Übergabe selbst verwalten?',
            answer:
              'Ja. Wir strukturieren den Online-Shop so, dass Sie ihn im Alltag einfach verwalten können. Zusätzlich erhalten Sie eine Anleitung oder Dokumentation, damit Ihr Team Produkte, Inhalte und Grundeinstellungen selbst aktualisieren kann. ',
          },
          {
            question: 'Wie lange dauert ein E-Commerce-Projekt?',
            answer:
              'Der Zeitplan hängt vom Umfang, der Anzahl der Seiten und Produkte sowie von den benötigten Integrationen und einer möglichen Migration ab. Nach einer ersten Analyse erstellen wir einen realistischen Zeitplan für die einzelnen Projektphasen. ',
          },
        ],
      },
      tech_seo: {
        overview:
          'Technisches SEO verbessert die technische Grundlage Ihrer Website, damit Suchmaschinen wichtige Seiten besser crawlen, verstehen und indexieren können. Dabei optimieren wir Performance, Struktur und Tracking und setzen klare Prioritäten für die weitere Entwicklung. ',
        outcomes: [
          'Klarer Überblick über technische Probleme, die das Ranking-Potenzial beeinträchtigen. ',
          'Bessere Ladezeiten, Core Web Vitals und mobile Nutzererfahrung. ',
          'Eine klare Struktur, die für Suchmaschinen und Analytics-Tools leichter verständlich ist. ',
          'Ein klar priorisierter Massnahmenplan nach Wirkung, Aufwand und Geschäftsrisiko.',
        ],
        when_to_use: [
          'Der organische Traffic ist niedrig, instabil oder schwer nachvollziehbar. ',
          'Wichtige Seiten erzielen in Suchmaschinen nicht die gewünschten Ergebnisse. ',
          'Die Website lädt langsam oder hat technische Probleme, insbesondere auf mobilen Geräten. ',
        ],
        workflow: [
          'Technische Analyse von Crawling, Indexierung, Geschwindigkeit und Struktur.',
          'Priorisierung der Probleme, die den grössten Einfluss auf Sichtbarkeit und Conversions haben. ',
          'Umsetzung oder technische Anleitung für Ihr Team.',
          'Monatlicher oder zweiwöchentlicher Bericht mit den wichtigsten Kennzahlen und der Entwicklung der Ergebnisse.',
        ],
        workflow_titles: [
          'Technisches Audit',
          'Priorisierung',
          'Umsetzung',
          'Follow-up',
        ],
        faq: [
          {
            question: 'Wie schnell zeigt technisches SEO Ergebnisse?',
            answer:
              'Verbesserungen bei Performance und Indexierung können bereits nach wenigen Wochen erste Ergebnisse zeigen. Verbesserungen im Ranking hängen jedoch von der bisherigen Entwicklung der Domain, dem Wettbewerb, den Inhalten und dem Crawling durch Google ab. ',
          },
          {
            question:
              'Setzen Sie die Optimierungen auch um oder liefern Sie nur einen Bericht? ',
            answer:
              'Beides ist möglich. Wir können Ihrem Team einen technischen Massnahmenplan zur Verfügung stellen oder die Umsetzung, Validierung und das Follow-up direkt begleiten. ',
          },
          {
            question: 'Ersetzt technisches SEO Content oder Ads?',
            answer:
              'Nein. Technisches SEO schafft die Grundlage dafür, dass Content und Kampagnen besser performen. In vielen Fällen können technische Optimierungen den Nutzen bestehender Inhalte deutlich steigern. ',
          },
        ],
      },
      analytics_schema: {
        overview:
          'Google Analytics & Schema ermöglicht eine zuverlässige Messung der Website-Performance und die Einbindung strukturierter Daten. So kann Ihr Team Ergebnisse besser nachvollziehen und Suchmaschinen können Ihre Seiten besser verstehen. ',
        outcomes: [
          'Google Analytics mit relevanten Events und Conversions konfiguriert.',
          'Google Tag Manager für eine einfachere spätere Verwaltung eingerichtet.',
          'Google-Shopping-Events implementiert, um wichtige Interaktionen nachzuverfolgen.',
          'Schema Markup für wichtige Seiten, Services, Produkte und Inhalte integriert.',
          'Technische Validierung zur Reduzierung von Mess- und Structured-Data-Fehlern.',
        ],
        when_to_use: [
          'Sie möchten sich auf Ihre Traffic- und Conversion-Daten verlassen können. ',
          'Wichtige Events werden nicht zuverlässig erfasst. ',
          'Sie möchten verbessern, wie Suchmaschinen Ihre Website verstehen. ',
          'Sie benötigen verlässliche Daten für Kampagnen und Entscheidungen. ',
        ],
        workflow: [
          'Wir definieren Ziele, Events, Conversions und priorisieren relevante Seiten. ',
          'Wir konfigurieren die notwendigen Tags, Events, Parameter und strukturierten Daten. ',
          'Wir prüfen die Datenerfassung, Trigger, Reports und das Schema Markup. ',
          'Wir dokumentieren das Setup für die weitere Wartung und Weiterentwicklung. ',
        ],
        workflow_titles: ['Planung', 'Einrichtung', 'Validierung', 'Übergabe'],
        faq: [
          {
            question: 'Richten Sie GA4 und Google Tag Manager ein?',
            answer:
              'Ja. Wir konfigurieren GA4, GTM, Events, Conversions, Parameter und Google-Shopping-Events passend zu den Zielen Ihrer Website. ',
          },
          {
            question: 'Hilft Schema Markup bei SEO?',
            answer:
              'Ja. Schema Markup hilft Suchmaschinen, Informationen besser zu verstehen und einzuordnen. Es garantiert keine besseren Rankings, verbessert aber die technische Struktur und Klarheit von Seiten, Produkten, Services und Inhalten.',
          },
          {
            question: 'Können Sie fehlerhafte Analytics-Daten korrigieren?',
            answer:
              'Ja. Wir prüfen die aktuelle Implementierung, identifizieren doppelte oder fehlende Erfassungen und optimieren die Datenerfassung.',
          },
        ],
      },
      pim: {
        overview:
          'PIM zentralisiert Produktinformationen in einer zuverlässigen Datenbasis für E-Commerce, ERP, Kataloge, Marktplätze und interne Teams. Dadurch werden Datenqualität und Konsistenz verbessert und Produktinformationen können schneller veröffentlicht werden. ',
        outcomes: [
          'Zentrale Produktdaten, die einfacher zu pflegen sind.',
          'Weniger Fehler in Beschreibungen, Attributen, Kategorien, Bildern und Übersetzungen.',
          'Stabilere Integrationen zwischen Geschäftssystemen und digitalen Kanälen.',
          'Schnellere Import-, Validierungs- und Exportprozesse.',
        ],
        when_to_use: [
          'Produktdaten liegen in verschiedenen Tabellen oder Systemen.',
          'Teams verlieren Zeit mit wiederholten Korrekturen.',
          'Sie verkaufen über mehrere Kanäle und benötigen konsistente Produktdaten.',
          'Das Wachstum Ihres Produktkatalogs erschwert die täglichen Abläufe. ',
        ],
        workflow: [
          'Analyse der bestehenden Daten, angebundenen Systeme und Geschäftsregeln.',
          'Modellierung von Attributen, Kategorien, Validierungen und Aktualisierungsprozessen.',
          'Integration mit ERP, E-Commerce, APIs oder Importdateien.',
          'Schulung und Dokumentation für die selbstständiges Arbeiten im Team.',
        ],
        workflow_titles: ['Mapping', 'Modellierung', 'Integration', 'Schulung'],
        faq: [
          {
            question:
              'Muss ich mein ERP- oder E-Commerce-System ersetzen, um PIM zu nutzen?',
            answer:
              'Normalerweise nicht. Das PIM lässt sich in Ihre bestehenden Systeme integrieren und mit ERP, E-Commerce, Marktplätzen oder anderen Datenquellen verbinden.',
          },
          {
            question: 'Wie unterstützt PIM den E-Commerce?',
            answer:
              'PIM zentralisiert Beschreibungen, Attribute, Bilder, Kategorien und Übersetzungen. So bleiben Produktdaten konsistent, Fehler werden reduziert und neue Inhalte können schneller veröffentlicht werden. ',
          },
          {
            question: 'Lohnt sich PIM auch für kleine Kataloge?',
            answer:
              'Ja, auch bei kleineren Katalogen kann PIM sinnvoll sein. Besonders hilfreich ist es bei vielen SKUs, Varianten, Sprachen, Vertriebskanälen oder wenn Produktdaten häufig aktualisiert werden müssen. ',
          },
          {
            question: 'Wird das Team geschult?',
            answer:
              'Ja. Wir schulen Ihr Team und stellen eine klare Dokumentation bereit, damit die Bereiche Produkt, Marketing und Technologie selbstständig mit dem PIM arbeiten und die Datenqualität langfristig sicherstellen können.',
          },
        ],
      },
      wordpress: {
        overview:
          'Der WordPress-Service umfasst die Erstellung, den Neuaufbau, die Optimierung und die technische Wartung von WordPress-Websites. Im Fokus stehen Performance, Sicherheit und eine einfache Verwaltung – ohne unnötig komplexe Plugin-Strukturen. ',
        outcomes: [
          'Mehr Geschwindigkeit: Kürzere Ladezeiten sorgen für eine bessere Nutzererfahrung. ',
          'Weniger Komplexität: Plugins, Themes und Einstellungen werden gezielt geprüft, um unnötige Abhängigkeiten zu vermeiden.',
          'Mehr Sicherheit: Eine sichere WordPress-Installation mit zuverlässigen Updates und regelmässigen Backups. ',
          'Mehr Autonomie: Eine klare Struktur, mit der Ihr Team Inhalte selbstständig verwalten kann, ohne bei jeder Änderung auf einen Entwickler angewiesen zu sein. ',
          'Mehr Planbarkeit: Eine solide WordPress-Basis, die Wartung, Weiterentwicklung und neue Funktionen langfristig erleichtert. ',
        ],
        when_to_use: [
          'Eine neue Website: Sie benötigen eine professionelle WordPress-Website, die einfach zu verwalten ist und mit Ihrem Unternehmen wachsen kann.',
          'Eine langsame Website: Ihre WordPress-Website lädt zu langsam, hat Performance-Probleme oder im Laufe der Zeit haben sich zu viele Plugins, Skripte und Konfigurationen angesammelt. ',
          'Regelmässige Wartung: Sie wollen Ihre Website aktuell, sicher und stabil halten, ohne Ihr Team zu WordPress-Spezialisten machen zu müssen. ',
        ],
        workflow: [
          'Wir analysieren die Website, Ihre Ziele und Inhalte sowie die aktuelle Struktur und die wichtigsten Herausforderungen. ',
          'Wir definieren die Architektur, die passenden Werkzeuge und die notwendigen Lösungen für das Projekt. ',
          'Wir setzen die Website mit Fokus auf Performance, Sicherheit, Benutzerfreundlichkeit und einfache Wartung um. ',
          'Wir veröffentlichen und testen die Website und dokumentieren das Projekt, damit Ihr Team sie selbstständig verwalten kann. ',
        ],
        workflow_titles: ['Analyse', 'Planung', 'Umsetzung', 'Übergabe'],
        faq: [
          {
            question: 'Arbeiten Sie mit bestehenden WordPress-Websites?',
            answer:
              'Ja. Wir können Websites übernehmen, die von anderen Teams oder Agenturen erstellt wurden, und diese warten, optimieren oder neu aufbauen. Bevor wir Änderungen vornehmen, führen wir eine technische Analyse durch, um Probleme mit der Struktur, den Plugins, der Performance und der Sicherheit zu erkennen.',
          },
          {
            question:
              'Kann man Plugins reduzieren, ohne Funktionen zu verlieren?',
            answer:
              'In den meisten Fällen ja. Wir analysieren, welche Plugins wirklich notwendig sind, welche durch native Funktionen oder einfachere Lösungen ersetzt werden können und welche zu Konflikten oder unnötiger Belastung führen. ',
          },
          {
            question: 'Ist WordPress sicher?',
            answer:
              'Ja, wenn es richtig konfiguriert und regelmässig gepflegt wird. Wir setzen auf Updates, eine sichere Rechteverwaltung, Hardening, Backups und weitere Schutzmassnahmen, um die wichtigsten Risiken einer WordPress-Installation zu minimieren.',
          },
          {
            question:
              'Meine Website ist langsam. Können Sie die Ursache finden?',
            answer:
              'Ja. Wir analysieren Installation, Hosting, Datenbank, Bilder, Cache, Plugins und Skripte, um die wichtigsten Engpässe zu identifizieren und gezielt die Optimierungen umzusetzen, die den grössten Einfluss auf die Performance haben. ',
          },
          {
            question: 'Arbeiten Sie mit Elementor?',
            answer:
              'Ja. Wir arbeiten mit bestehenden Elementor-Websites und nutzen Elementor auch für neue Projekte, wenn es zu den Anforderungen des Projekts passt. ',
          },
          {
            question: 'Bieten Sie nach der Lieferung Wartung an?',
            answer:
              'Ja. Nach Abschluss des Projekts kann Ihr Team die Verwaltung übernehmen oder wir betreuen Ihre Website im Rahmen eines Wartungsplans weiter. ',
          },
          {
            question:
              'Können Sie eine Website neu aufbauen, ohne komplett von vorne anzufangen?',
            answer:
              'Ja. Zuerst prüfen wir, welche Teile der bestehenden Website weiterverwendet werden können und wo Anpassungen notwendig sind. Oft ist es effizienter, nur bestimmte Bereiche oder Strukturen neu aufzubauen, anstatt die gesamte Website zu ersetzen. ',
          },
          {
            question: 'Wie viel kostet ein WordPress-Projekt?',
            answer:
              'Der Preis hängt vom Umfang, der Anzahl der Seiten, den Integrationen, dem Grad der Individualisierung und dem aktuellen Zustand der Website ab. Bei grösseren Projekten führen wir zunächst eine Analyse durch und erstellen anschliessend ein Angebot auf Basis des definierten Projektumfangs. ',
          },
          {
            question: 'Warum WordPress verwenden?',
            answer:
              'WordPress bietet eine gute Kombination aus Flexibilität, einfacher Verwaltung und vielseitigen Entwicklungsmöglichkeiten und eignet sich daher für viele Unternehmenswebsites und digitale Projekte. Wir empfehlen WordPress jedoch nicht grundsätzlich, sondern prüfen die Anforderungen jedes Projekts und wählen die Lösung, die am besten zum Unternehmen passt. ',
          },
        ],
      },
      ux: {
        overview:
          'Modernisierung der Website-Oberfläche mit Fokus auf Usability, Barrierefreiheit und User Experience. Dazu gehören eine verbesserte Navigation, eine klare Strukturierung der Inhalte, responsives Design, eine klare visuelle Hierarchie sowie einheitliche Elemente und intuitive, benutzerfreundliche Interfaces, die zur Markenidentität passen. ',
        outcomes: [
          'Klarere Seiten, die sich schneller erfassen und leichter verstehen lassen. ',
          'Buttons, Formulare und Nutzerwege, die einfacher und intuitiver funktionieren. ',
          'Mehr visuelle Konsistenz auf Desktop, Tablet und Mobilgeräten. ',
          'Konkrete Empfehlungen für mehr Conversion und Vertrauen. ',
        ],
        when_to_use: [
          'Nutzer verlassen die Seite, bevor sie wichtige Aktionen ausführen. ',
          'Das Layout wirkt veraltet, unübersichtlich oder inkonsistent. ',
          'Die mobile Navigation ist umständlich oder nicht intuitiv. ',
          'Sie möchten die Conversion verbessern, ohne die gesamte Website neu aufzubauen. ',
        ],
        workflow: [
          'Analyse der aktuellen Nutzererfahrung, visuellen Hierarchie, Nutzerwege und möglichen Hürden. ',
          'Priorisierung der Verbesserungen mit dem grössten Einfluss auf Klarheit und Conversion. ',
          'Erstellung von Prototypen oder direkte Umsetzung der Layout-Anpassungen. ',
          'Prüfung der Darstellung auf verschiedenen Geräten und Empfehlungen für weitere Optimierungen. ',
        ],
        workflow_titles: [
          'UX-Analyse',
          'Priorisierung',
          'Prototyp',
          'Überprüfung',
        ],
        faq: [
          {
            question:
              'Muss die ganze Website neu gebaut werden, um die UX zu verbessern?',
            answer:
              'Nicht immer. Viele Verbesserungen lassen sich bereits durch eine klare Hierarchie, passende Abstände, eine bessere Navigation sowie optimierte Buttons, Formulare und responsive Anpassungen erreichen – ohne die gesamte Website neu aufzubauen. ',
          },
          {
            question: 'Liefern Sie Prototypen oder setzen Sie direkt um?',
            answer:
              'Das hängt vom Projektumfang ab. Wir können Prototypen und visuelle Empfehlungen erstellen oder die gewünschten Anpassungen direkt umsetzen. ',
          },
          {
            question: 'Verbessert UX die Conversion?',
            answer:
              'Ja. Eine klare und intuitive Oberfläche reduziert Hürden, schafft Vertrauen und erleichtert wichtige Aktionen wie Kontaktaufnahme, Kauf, Registrierung oder Angebotsanfragen. ',
          },
          {
            question: 'Wie lässt sich die Leseerfahrung verbessern?',
            answer:
              'Wir können Texte, Schriftgrössen, Abstände und die Struktur anpassen, damit Inhalte leichter und angenehmer zu lesen sind. ',
          },
          {
            question: 'Können Sie Formulare verbessern?',
            answer:
              'Ja. Wir können Felder vereinfachen, Hinweise klarer formulieren und das Ausfüllen erleichtern. ',
          },
          {
            question: 'Kann das dunkle Theme automatisch aktiviert werden?',
            answer:
              'Ja. Es kann manuell aktiviert werden oder sich automatisch an die Einstellungen des Geräts anpassen. ',
          },
          {
            question: 'Kann die Optimierung die mobile Erfahrung verbessern?',
            answer:
              'Ja. Wir optimieren Grössen, Menüs, Buttons und die Anordnung der Inhalte für kleinere Bildschirme. ',
          },
          {
            question:
              'Kann der aktuelle Stil beibehalten und trotzdem modernisiert werden?',
            answer:
              'Ja. Eine komplett neue visuelle Identität ist nicht notwendig, um das Layout zu modernisieren und zu verbessern.',
          },
          {
            question: 'Können Sie auch die Website-Texte optimieren?',
            answer:
              'Ja. Wir können Navigationstexte, Titel, Calls-to-Action und Inhalte optimieren, damit sie klarer und leichter verständlich sind.',
          },
          {
            question: 'Verändert die Optimierung die Markenidentität?',
            answer:
              'Nicht unbedingt. Farben, Logo und der visuelle Markenauftritt können beibehalten werden, während wir die Oberfläche modernisieren. ',
          },
          {
            question: 'Können überladene Seiten verbessert werden?',
            answer:
              'Ja. Wir können Inhalte und Elemente neu strukturieren und reduzieren, damit die Seite übersichtlicher und leichter verständlich wird. ',
          },
        ],
      },
      digital_link_page: {
        overview:
          'Wir erstellen individuell gestaltete digitale Linkseiten, die wichtige Links, Social-Media-Kanäle, Kontaktdaten und Angebote übersichtlich an einem Ort bündeln. ',
        outcomes: [
          'Eine Linkseite mit einer visuellen Identität, die zur Marke passt. ',
          'Links, Social Media, Kontaktdaten und Angebote übersichtlich an einem Ort. ',
          'Schnelle und responsive Darstellung auf Smartphone, Tablet und Desktop. ',
          'Einfache Struktur für Aktualisierungen und Kampagnen. ',
        ],
        when_to_use: [
          'Sie suchen eine professionelle Alternative zu klassischen Link-in-Bio-Lösungen. ',
          'Wichtige Links sind auf zu viele Kanäle verteilt. ',
          'Sie wollen Kontakte, Social Media, Angebote oder Kampagnen hervorheben. ',
          'Ihr Team soll Links einfacher verwalten und aktualisieren können. ',
        ],
        workflow: [
          'Wir erfassen Links, Kanäle, Angebote und Kommunikationsprioritäten. ',
          'Wir definieren die Struktur, die visuelle Hierarchie und die Identität der Seite. ',
          'Wir erstellen eine schnelle, responsive und benutzerfreundliche Seite. ',
          'Wir veröffentlichen die Seite und geben Ihrem Team Hinweise für zukünftige Aktualisierungen. ',
        ],
        workflow_titles: [
          'Planung',
          'Struktur',
          'Umsetzung',
          'Veröffentlichung',
        ],
        faq: [
          {
            question: 'Ersetzt das eine komplette Website?',
            answer:
              'Nicht unbedingt. Die Linkseite dient als schneller Einstieg zu wichtigen Kanälen, Kontakten und Angeboten und kann eine vollständige Website sinnvoll ergänzen. ',
          },
          {
            question: 'Kann die Seite an die Markenidentität angepasst werden?',
            answer:
              'Ja. Wir können Farben, Typografie, Texte und Aufbau passend zur Marke gestalten.',
          },
          {
            question: 'Kann man Klicks messen?',
            answer:
              'Ja. Wir können das Tracking so einrichten, dass Klicks erfasst werden und sichtbar wird, welche Links besonders häufig genutzt werden. ',
          },
        ],
      },
      cyber: {
        overview:
          'Wir identifizieren Sicherheitsrisiken in Websites und Systemen und zeigen konkrete Verbesserungsmöglichkeiten auf. Ziel ist es, Schwachstellen gezielt zu beheben, Risiken zu reduzieren und kritische Bereiche nachhaltig abzusichern. ',
        outcomes: [
          'Klarer Überblick über die wichtigsten technischen und operativen Risiken. ',
          'Bessere Kontrolle über Zugriffe, Authentifizierung, Berechtigungen und den Schutz sensibler Daten. ',
          'Bericht mit identifizierten Schwachstellen, klaren Prioritäten und konkreten Empfehlungen zur Behebung. ',
          'Weniger Schwachstellen in Websites, APIs, Servern und Abhängigkeiten. ',
        ],
        when_to_use: [
          'Website oder System verarbeitet sensible Kundendaten.',
          'Zugriffe und Berechtigungen wurden längere Zeit nicht überprüft. ',
          'Audits, Wachstum oder externe Integrationen stehen bevor.',
          'Updates, Backups und Monitoring sind noch nicht klar strukturiert. ',
        ],
        workflow: [
          'Wir erfassen Assets, Zugriffe, Integrationen und mögliche Sicherheitsrisiken. ',
          'Wir prüfen Einstellungen, Abhängigkeiten, Berechtigungen und sicherheitsrelevante Konfigurationen. ',
          'Wir erstellen einen Massnahmenplan nach Schweregrad, Aufwand und Priorität. ',
          'Wir überprüfen die umgesetzten Verbesserungen und geben Empfehlungen für das weitere Monitoring. ',
        ],
        workflow_titles: ['Erfassung', 'Bewertung', 'Korrektur', 'Monitoring'],
        faq: [
          {
            question: 'Ist Penetration Testing enthalten?',
            answer:
              'Der Standardumfang umfasst die Bewertung von Sicherheitsrisiken, Hardening und konkrete Massnahmen zur Risikoreduktion. Umfangreichere Penetration Tests können je nach Bedarf und nach vorheriger Absprache separat durchgeführt werden. ',
          },
          {
            question: 'Beheben Sie auch gefundene Probleme?',
            answer:
              'Ja. Wir können gefundene Probleme direkt beheben oder gemeinsam mit Ihrem Team umsetzen. Dabei priorisieren wir nach Schweregrad, Risiko und Aufwand. ',
          },
          {
            question: 'Ist dieser Service nur für grosse Unternehmen?',
            answer:
              'Nein. Auch kleine und mittlere Unternehmen müssen Zugänge, Daten, Backups, Abhängigkeiten und Websites schützen – besonders wenn wichtige Geschäftsprozesse digital ablaufen. ',
          },
        ],
      },
      audit: {
        overview:
          'Das Audit bietet einen schnellen, strukturierten Überblick über Datenschutz, Performance, SEO, Barrierefreiheit, Usability und Sicherheit. Es hilft, die wichtigsten Schwachstellen zu erkennen und Verbesserungen gezielt zu priorisieren – zum Beispiel vor einem grösseren Projekt. ',
        outcomes: [
          'Objektive Analyse der wichtigsten Stärken und Schwächen der Website.',
          'Priorisierte Verbesserungsliste mit klarer Einschätzung der erwarteten Auswirkungen.',
          'Technische Grundlage für fundierte Investitionsentscheidungen. ',
          'Umsetzbare Empfehlungen für kurz- und mittelfristige Maßnahmen. ',
        ],
        when_to_use: [
          'Sie möchten wissen, womit Sie vor Entwicklungsarbeiten beginnen sollten. ',
          'Ihre Website besteht bereits, aber die kommerzielle oder technische Performance ist unklar. ',
          'Es bestehen Fragen zu Datenschutz, SEO, Barrierefreiheit oder Sicherheit. ',
          'Sie benötigen klare Prioritäten für Stakeholder oder die Geschäftsleitung. ',
        ],
        workflow: [
          'Sammlung von Zielen, Rahmenbedingungen und den zu prüfenden URLs oder Systemen. ',
          'Technische Analyse mit geeigneten Tools, manueller Prüfung und relevanten Business-Kriterien. ',
          'Priorisierung der Ergebnisse nach Schweregrad, Auswirkungen und Korrekturaufwand. ',
          'Bericht mit klaren Empfehlungen und anschliessender Abstimmung. ',
        ],
        workflow_titles: ['Kontext', 'Analyse', 'Priorisierung', 'Bericht'],
        faq: [
          {
            question: 'Ist ein Audit vor einem grösseren Projekt sinnvoll?',
            answer:
              'Ja. Es hilft, die wichtigsten Prioritäten zu erkennen, bevor in Redesign, Entwicklung, SEO, Sicherheit oder Performance investiert wird.',
          },
          {
            question: 'Ist der Bericht zu technisch?',
            answer:
              'Nein. Wir bereiten die Ergebnisse verständlich auf, erklären ihre Auswirkungen und zeigen klare nächste Schritte. Technische Details werden dort ergänzt, wo sie für die Umsetzung relevant sind. ',
          },
          {
            question: 'Können Sie Verbesserungen nach dem Audit umsetzen?',
            answer:
              'Ja. Auf Basis des Audits können wir einen konkreten Umsetzungsplan mit Prioritäten und Budget erstellen und Sie bei der Umsetzung der Verbesserungen begleiten. ',
          },
        ],
      },
    },
    features: {
      ux_modern_layout:
        'Modernes Layout: ein zeitgemässer und professioneller visueller Auftritt',
      ux_better_navigation:
        'Verbesserte Navigation: schneller und einfacher Zugang zu wichtigen Informationen ',
      ux_usability:
        'Mehr Usability: eine einfache und benutzerfreundliche Nutzung ',
      ux_accessibility:
        'Barrierefreiheit: bessere Lesbarkeit und einfachere Interaktion ',
      ux_responsive_design:
        'Responsives Design: optimale Darstellung auf allen Geräten ',
      ux_intuitive_interface:
        'Intuitive Oberfläche: klare Strukturen und verständliche Interaktionen',
      ux_light_dark_theme:
        'Helles und dunkles Theme: mehr Komfort und individuelle Anpassungsmöglichkeiten ',
      link_page_links: 'Wichtige Links übersichtlich an einem Ort ',
      link_page_socials: 'Social-Media-Kanäle klar hervorgehoben ',
      link_page_contact: 'Kontaktdaten schnell und einfach zugänglich ',
      link_page_offers:
        'Angebote, Kampagnen oder Calls-to-Action gezielt hervorgehoben ',
      link_page_responsive:
        'Schnelle, responsive und individuell gestaltete Seite ',
      up_to_pages: 'Bis zu {{count}} Seiten',
      unlimited_pages: 'Unbegrenzte Seiten',
      text_images_tables: 'Texte, Bilder und Tabellen',
      nav_footer: 'Navigation und Footer',
      cookie_banner: 'Cookie-Consent-Banner',
      professional_email: 'Professionelle E-Mail',
      third_party_api: 'Integration von Drittanbieter-APIs',
      cms_database: 'CMS / Datenbank',
      ecommerce: 'E-Commerce',
      previous_features: 'Alle Funktionen der vorherigen Pläne',
      full_ecommerce: 'Komplette E-Commerce-Konfiguration',
      on_demand: 'On-Demand-Funktionen',
      deliverable_seo_audit:
        'Technische SEO-Analyse mit klarem Massnahmenplan für mehr Sichtbarkeit',
      deliverable_cw_vitals: 'Optimierung von Ladezeit und Nutzererlebnis',
      deliverable_accessibility: 'Sicherstellen der Barrierefreiheit',
      deliverable_indexing: 'Bessere Auffindbarkeit und Indexierung',
      delivery_weekly_report:
        'Monatlicher Performance-Bericht mit konkreten nächsten Schritten',
      ga4_setup: 'Google Analytics 4 Setup',
      gtm_events: 'Events, Conversions und Google Tag Manager',
      google_shopping_events: 'Optional: Google-Shopping-Events',
      schema_markup: 'Schema Markup für Seiten, Produkte und Dienstleistungen',
      analytics_validation: 'Technische Validierung von Daten und Tracking',
      pim_integration:
        'Integration des PIM mit E-Commerce / ERP (Oracle, Abacus, Bling)',
      pim_data_model: 'Datenmodell und Attributstrategie',
      pim_import_export: 'Import-/Export-Pipelines und Automatisierung',
      pim_quality_rules: 'Datenqualitäts- und Validierungsregeln',
      delivery_hand_over:
        'Klare Dokumentation und Schulung, damit Ihr Team selbstständig arbeiten kann',
      ecommerce_store_setup: 'Erstellung oder Neugestaltung eines Online-Shops',
      ecommerce_catalog_checkout:
        'Strukturierter Katalog, optimierte Produktseiten und zuverlässiger Checkout',
      ecommerce_integrations:
        'Integrationen für Zahlungsabwicklung, Logistik, ERP und PIM',
      ecommerce_performance_tracking:
        'Optimiert für Performance, SEO und nachhaltiges Wachstum',
      wp_build_or_rebuild: 'Erstellung und Neuaufbau',
      wp_performance: 'Performance und Geschwindigkeit',
      wp_security_hardening: 'Sicherheit und Stabilität',
      wp_plugins_quality: 'Plugins, Themes und Architektur',
      delivery_monthly_maintenance: 'Kontinuierliche Wartung',
      wp_technical_seo: 'Technisches SEO',
      cyber_risk_assessment: 'Risikobewertung & Bedrohungsanalyse',
      cyber_website_security: 'Sicherheitsanalyse von Websites',
      cyber_api_security: 'API-Sicherheit',
      cyber_code_security: 'Code-Sicherheitsanalyse ',
      cyber_monitoring: 'Überwachung und Warnmeldungen bei kritischen Risiken ',
      delivery_security_report:
        'Sicherheitsbericht mit Prioritäten und Zeitplan',
    },
    cta_get_started: 'Jetzt starten',
    cta_request_proposal: 'Angebot anfordern',
    whatsapp_message:
      'Hallo! Ich möchte den Service "{{service}}" zum Preis von {{price}} buchen, wie auf der Website angezeigt.',
    long_term_note:
      'Sonderkonditionen für langfristige Projekte und Verträge verfügbar.',
    long_term_cta: 'Besprechen Sie Ihr Projekt jetzt!',
    long_term_whatsapp_message:
      'Hallo! Ich möchte ein Projekt besprechen und mehr über die Sonderkonditionen für langfristige Projekte und Verträge erfahren.',
    price_on_request: 'Preis auf Anfrage',
    commercial_table_title: 'Kommerzielle Konditionen',
    commercial_table: {
      billing: 'Abrechnung',
      hourly_rate: 'Stundensatz',
      commitment: 'Bindung',
      rows: {
        row_0: {
          billing: '0',
          hourly_rate: '50 CHF',
          commitment: 'Keine Bindung',
        },
        row_1: {
          billing: "15'000",
          hourly_rate: '45 CHF',
          commitment: '4 Tage pro Monat. Mindestlaufzeit 3 Monate.',
        },
        row_2: {
          billing: "30'000",
          hourly_rate: '40 CHF',
          commitment: '8 Tage pro Monat. Mindestlaufzeit 3 Monate.',
        },
        row_3: {
          billing: "45'000",
          hourly_rate: '35 CHF',
          commitment: '14 Tage pro Monat. Mindestlaufzeit 6 Monate.',
        },
        row_4: {
          billing: "60'000",
          hourly_rate: '30 CHF',
          commitment: '21 Tage pro Monat. Mindestlaufzeit 6 Monate.',
        },
      },
    },
    extras_title: 'Extras & Wartung',
    extras: {
      cookie_banner: {
        title: 'Cookie-Banner',
        desc: 'Bleiben Sie datenschutzkonform und schaffen Sie Vertrauen bei Ihren Besuchern.',
      },
      professional_email: {
        title: 'Professionelle E-Mail',
        desc: 'E-Mail-Einrichtung mit Ihrer Marke für einen professionellen Auftritt.',
      },
      audits: {
        title: 'Audits',
        desc: 'Umfassende Auditierung von Datenschutz, Performance (SEO) und Umweltimpact (CO2-Fussabdruck).',
      },
      maintenance: {
        title: 'Wartung',
        desc: 'Halten Sie Ihre Website sicher und aktuell.',
        tier_individual: '(Individual)',
        tier_business: '(Business)',
        tier_custom: '(Individuell)',
      },
    },
    faq_title_prefix: 'Häufig',
    faq_title_accent: 'gestellte Fragen',
    faq: {
      q1: 'Was ist ein PIM und wofür ist es da?',
      a1: 'Ein PIM (Product Information Management) ist ein System, das Produktinformationen zentralisiert, organisiert, validiert und an alle Vertriebs- und Kommunikationskanäle verteilt – z. B. E-Commerce, ERP, Marktplätze, Kataloge und APIs. So bleiben die Daten konsistent, die Datenqualität steigt und Produkte können schneller veröffentlicht werden.',
      q2: 'Kann mein Team das PIM einfach nutzen?',
      a2: 'Ja. Das PIM wird so konfiguriert, dass Produkt-, Marketing- und Tech-Teams es gut im Alltag nutzen können. Das Projekt beinhaltet ausserdem klare Dokumentation, Training und Governance-Best-Practices – damit euer Team autonom und effizient arbeiten kann.',
      q3: 'Welche konkreten Layout-&-UX-Verbesserungen macht ihr in der Praxis?',
      a3: 'Wir verbessern Layout & UX ganz pragmatisch: Wir machen die Seite wirklich responsiv (Mobile, Tablet und Desktop funktionieren sauber), ordnen die Hierarchie und feilen an Abständen, Typografie und Kontrast, damit das Layout cleaner, hochwertiger und professioneller wirkt. Ausserdem optimieren wir Navigation und Buttons, damit die Nutzung intuitiver und flüssiger wird – weniger Reibung, mehr Klarheit – inklusive verbesserter Barrierefreiheit, damit wirklich alle gut damit zurechtkommen.',
      q4: 'Was ist SEO und warum ist es wichtig für meine Website?',
      a4: 'SEO (Search Engine Optimization) sind Massnahmen, die dafür sorgen, dass deine Website in Suchergebnissen (z. B. bei Google) besser sichtbar wird. Gutes SEO erhöht die Reichweite, bringt qualifizierten Traffic und schafft organisch mehr Business-Chancen – ohne nur von bezahlten Ads abhängig zu sein.',
      q6: 'Welche Massnahmen kann ich ergreifen, um mein Google-Ranking zu verbessern?',
      a6: 'Wichtige Massnahmen sind u. a. Titel und Beschreibungen zu optimieren, relevante Keywords einzusetzen, hochwertige Inhalte zu erstellen, die Website schneller zu machen, eine starke Mobile-Experience sicherzustellen und die Seite technisch sauber für Suchmaschinen zu strukturieren.',
      q7: 'Was ist Cybersicherheit und wie schützt sie meine Website oder mein System?',
      a7: 'Cybersicherheit umfasst Praktiken, Technologien und Prozesse, die Systeme, Netzwerke und Daten vor digitalen Angriffen, unbefugtem Zugriff und Datenlecks schützen – und so Integrität, Vertraulichkeit und Verfügbarkeit sicherstellen.',
      q8: 'Was sind die wichtigsten Massnahmen, um meine Daten und Nutzer zu schützen?',
      a8: 'Zu den wichtigsten Massnahmen gehören SSL-Zertifikate, starke Passwörter, Zwei-Faktor-Authentifizierung, regelmässige Updates von Systemen und Abhängigkeiten, regelmässige Backups, Zugriffskontrolle sowie kontinuierliches Monitoring möglicher Bedrohungen.',
      q9: 'Welche konkreten Ergebnisse kann eine Audit für mein Unternehmen bringen?',
      a9: 'Die Audit bringt sehr direkte Business-Effekte: Sie verbessert Speed und Nutzererlebnis (vor allem auf Mobile), reduziert Reibung in der Navigation und steigert Conversions bei Aktionen wie Kauf, Registrierung oder Angebotsanfrage; stärkt technisches SEO, um organischen Traffic zu erhöhen; findet und behebt Privacy- und Compliance-Lücken, um Risiken zu senken und Vertrauen aufzubauen; zeigt Schwachstellen über eine essenzielle Security-Checkliste; verbessert Accessibility und Usability, damit mehr Menschen die Seite klar und gut nutzen können; und empfiehlt Optimierungen, die Seitengewicht und Ressourcenverbrauch senken – was Kosten und Umweltimpact reduziert.',
      q10: 'Was sind WordPress-Projekte?',
      a10: 'WordPress-Projekte sind Arbeiten, bei denen eine Website (oder ein Teil davon) mit WordPress erstellt, angepasst oder optimiert wird – WordPress ist eine Plattform zum Erstellen und Verwalten von Inhalten. In der Praxis umfasst das z. B. Unternehmensseiten, Blogs oder Landingpages, Online-Shops mit WooCommerce, Layout- und Responsive-Anpassungen, Konfiguration von Plugins für SEO, Performance, Formulare und Sicherheit, Integrationen (z. B. CRM, Analytics, Payments) sowie Wartung, Updates und Bugfixes – damit die Website schneller, sicherer und in der Nutzung besser wird.',
    },
  },
  customers: {
    title: 'Unsere Kunden',
  },
  marquee: {
    ariaLabel: 'Highlights',
    line1: 'INDIVIDUELLE ENTWICKLUNG – API-INTEGRATIONEN – CMS – E-COMMERCE',
    line2:
      'TECHNISCHES SEO – PERFORMANCE – BARRIEREFREIHEIT – WEB VITALS – AUDITS',
  },
  pagenotfound: {
    tagline:
      'Abseits des Bergpfads – folge dem Blau des Sees zurück nach Hause.',
    backHome: 'Zur Startseite',
    notFound: 'Seite nicht gefunden',
  },
  welcome_message: 'Willkommen in meinem Portfolio',
  instagramLinks: {
    ariaLabel: 'BlueAlps Social Links',
    shareLabel: 'Teilen',
    bio: [
      'Schweizer Technologie, brasilianisches Talent.',
      'Wir entwickeln innovative digitale Lösungen',
      'für Unternehmen, die wachsen wollen.',
    ],
    cards: {
      instagram: {
        title: 'Instagram',
        subtitle: 'Folgen Sie unseren Updates, Projekten und Einblicken.',
        cta: 'Profil ansehen',
      },
      website: {
        title: 'BlueAlps',
        subtitle: 'Lernen Sie unsere digitalen Lösungen kennen.',
        cta: 'Website besuchen',
      },
      whatsapp: {
        title: 'WhatsApp',
        subtitle: 'Sprechen Sie direkt mit unserem Team.',
        cta: 'Nachricht senden',
      },
      booking: {
        title: 'Microsoft Bookings',
        subtitle: 'Buchen Sie kostenlos einen Termin mit unserem Team.',
        cta: 'Termin buchen',
      },
    },
    footer: [
      {
        label: 'Cookie-Einstellungen',
        href: '/cookie-policy',
      },
      {
        label: 'Melden',
        href: '/contact',
      },
      {
        label: 'Datenschutz',
        href: '/privacy-policy',
      },
      {
        label: 'Über dieses Konto',
        href: '/imprint',
      },
      {
        label: 'Mehr von BlueAlps',
        href: '/',
      },
    ],
  },
  footer: {
    extra_links: 'Zusätzliche Links',
    home: 'Startseite',
    about: 'Über uns',
    services: 'Dienstleistungen',
    project: 'Projekte',
    impact: 'Wirkung',
    contact_button: 'Kontakt',
    imprint: 'Impressum',
    privacy: 'Datenschutzerklärung',
    cookie: 'Cookie-Richtlinie',
  },
  home: {
    hero: {
      eyebrow: 'RESPONSIBLE IT',
      title_line1: 'Hochwertige Software',
      title_line2: 'zu fairen Preisen.',
    },
    cta_primary: 'Jetzt starten',
    caption: 'Softwareentwicklung mit Qualität und Kosteneffizienz.',
    more_info: 'Mehr über uns erfahren',
    more_info_services: 'Entdecken Sie jetzt unsere Dienstleistungen',
    services_teaser_title:
      'Finden Sie Expertinnen und Experten, um Ihre digitale Transformation zu beschleunigen',
    services_teaser_subtitle:
      'Experten auf Abruf für Softwareentwicklung, künstliche Intelligenz, SEO, PIM, WordPress, Cybersicherheit und vieles mehr.',
    services_teaser_price_note:
      'Sprechen Sie mit uns, um den passenden Spezialisten für Ihre Herausforderung zu finden.',
    services_teaser_cta: 'Unsere Services entdecken',
    services_teaser_custom_quote: 'Individuelles Angebot anfragen',
    purposetitle_part1: 'Technologie,',
    purposetitle_part2: 'die Innovation und Wirkung verbindet',
    purpose:
      'BlueAlps ist ein schweizerisch-brasilianisches Technologieunternehmen, das auf individuelle Softwareentwicklung, künstliche Intelligenz, Automatisierung und digitale Transformation für Unternehmen spezialisiert ist. \n' +
      '\n' +
      'Wir verbinden brasilianische Kreativität mit Schweizer Präzision, um skalierbare, sichere und hochwertige Technologielösungen zu entwickeln. So unterstützen wir Unternehmen dabei, Innovationen voranzutreiben, Prozesse zu optimieren und nachhaltiges Wachstum zu beschleunigen. Dabei handeln wir mit klarem Fokus auf technische Exzellenz und gesellschaftlichen Mehrwert – stets geleitet von unseren Werten: Chancengleichheit, Inklusion, Integrität, Zusammenarbeit und Nachhaltigkeit. ',
    purpose_values_label: 'BlueAlps Werte',
    purpose_values: {
      equity: 'Chancengleichheit',
      inclusion: 'Inklusion',
      integrity: 'Integrität',
      collaboration: 'Zusammenarbeit',
      sustainability: 'Nachhaltigkeit',
    },
    company_cta: 'Mehr über unser Unternehmen erfahren',
    vision_title: 'Vision',
    vision_text:
      'Unsere Vision ist es, soziale Ungleichheiten zu verringern und eine fairere, inklusivere, vielfältigere und nachhaltigere Welt zu fördern, indem wir die Stärken zweier komplementärer Kulturen – Brasilien und die Schweiz – verbinden. Wir inspirieren und ermöglichen positiven Wandel durch gesellschaftlich engagiertes Engineering, das technische Innovation mit sozialer Verantwortung vereint.',
    mission_title: 'Mission',
    mission_text:
      'Unsere Mission ist es, kleine und mittlere Unternehmen mit barrierefreien und leistungsstarken Softwarelösungen zu unterstützen, die sich an den UN-Zielen für nachhaltige Entwicklung (SDGs) orientieren. Wir verbinden technisches Know-how mit Arbeitsweisen, die Gerechtigkeit, Chancengleichheit, Vielfalt und Nachhaltigkeit fördern. Über unsere Dienstleistungen hinaus leben wir die von uns vertretenen Werte und schaffen so ein sicheres, inklusives und moralisch gefestigtes Umfeld für unser Team und unsere Kunden.',
    core_values: 'Kernwerte',
    core_values_text:
      'Die Werte der Organisation sind das Fundament ihrer Identität und leiten alle Entscheidungen. Sie prägen die Unternehmenskultur und die Wirkung, den wir erzeugen.',
    core_values_list_Equity: 'Chancengerechtigkeit',
    core_values_list_Equity_text:
      'Faire Chancen und Ergebnisse für alle – durch Gerechtigkeit in Partnerschaften, Prozessen und am Arbeitsplatz.',
    core_values_list_InclusionDiversity: 'Inklusion & Vielfalt',
    core_values_list_InclusionDiversity_text:
      'Einladende Umgebungen schaffen, die unterschiedliche Stimmen, Hintergründe und Erfahrungen wertschätzen.',
    core_values_list_Integrity: 'Integrität',
    core_values_list_Integrity_text:
      'Transparentes und ethisches Handeln in allen Interaktionen – mit Kunden, Kolleginnen und Kollegen sowie der Gemeinschaft.',
    core_values_list_Sustainability: 'Nachhaltigkeit',
    core_values_list_Sustainability_text:
      'Entscheidungen treffen, die ökologische, soziale und wirtschaftliche Gesundheit fördern – heute und in Zukunft.',
    core_values_list_Collaboration: 'Zusammenarbeit',
    core_values_list_Collaboration_text:
      'Wachstum durch gemeinsames Wirken und starke Partnerschaften auf Basis von Respekt und gemeinsamen Zielen.',
    two_nations1: 'Ideen ohne Grenzen:',
    two_nations2: 'Zwei Nationen vereinen',
    switzerland: 'Schweiz',
    brazil: 'Brasilien',
    linkedin_link_label: 'LinkedIn ansehen - Profil von {{name}}',
    linkedin_link_text: 'LinkedIn ansehen',
    our_mission: 'Unsere Mission',
    our_mission_text:
      'Wir glauben, dass Software ein Werkzeug für soziale Transformation sein sollte. Bei BlueAlps trennen wir technische Exzellenz nicht von Nachhaltigkeit.',
    our_essence: 'Unsere Essenz',
    our_essence_text:
      'Wir leben unsere Werte. Wir handeln verantwortungsbewusst und führen mit \tEmpathie. Für uns entsteht eine nachhaltige Zukunft durch die Entscheidungen, \tdie wir jeden Tag gemeinsam treffen.',
    our_commitment: 'Unser Engagement',
    our_commitment_text:
      'Wir arbeiten mit Purpose. Wir handeln verantwortungsbewusst. Wir führen mit Empathie. Denn eine nachhaltige Zukunft ist keine ferne Idee – sie ist eine kollektive Entscheidung, die wir jeden Tag treffen.',
    value_proposition: 'Wertversprechen',
    value_proposition_text:
      'Wir liefern modernste Softwarelösungen mit Seele, erzeugen messbare Ergebnisse für Ihr Unternehmen und eine positive Wirkung für die Gemeinschaft – Effizienz verbunden mit sozialer Verantwortung.',
    develop_conscious1:
      'Wir entwickeln bewusste digitale Lösungen, massgeschneidert für alle, die',
    develop_conscious2: 'an Technologie mit Impact glauben',
    develop_conscious_text:
      'Bei BlueAlps reduzieren wir soziale Ungleichheiten durch intelligentes, zugängliches Engineering. Inklusion, Würde und Zusammenarbeit prägen alles, was wir tun – gemeinsam mit Partnern, die unsere Werte teilen.',
    commitment: 'Engagement',
    commitment_text:
      'BlueAlps ist mehr als eine Beratung – es ist ein Engagement für sinnvolle Transformation. Unsere Projekte ist purpose-driven, wertebasiert und in Partnerschaft mit jenen gestaltet, die wie wir an eine ausgewogenere und nachhaltigere Welt glauben.',
    software_development: 'Softwareentwicklung',
    software_development_text:
      'Wir glauben, dass Engineering ein Werkzeug für soziale Transformation sein kann – und sein muss. Bei BlueAlps trennen wir technische Exzellenz nicht von menschlichem Impact. Wir vereinen die Präzision der Schweizer Ingenieurskunst mit der Kreativität und Resilienz der brasilianischen Kultur, um Lösungen zu bauen, die effizient und gerecht sind. Wir arbeiten mit Purpose, handeln verantwortungsbewusst und führen mit Empathie. Denn eine nachhaltige Zukunft ist keine ferne Idee – sie ist eine kollektive Entscheidung, die wir täglich in Design, Prozessen und Beziehungen treffen.',
    ecommerce: 'E-Commerce',
    ecommerce_text:
      'BlueAlps unterstützt sozial engagierte Unternehmen mit hochwertigen, zugänglichen und zweckorientierten Engineering-Lösungen, die mit globalen Nachhaltigkeitszielen im Einklang stehen. Wir verbinden technische Präzision, inklusive Praktiken und tiefes Business-Verständnis, um wirkungsvolle E-Commerce-Plattformen zu schaffen, die Wachstum und sozialen Wandel fördern.',
    team_text1:
      'Wir vereinen globale Talente, um leistungsstarke Software zu entwickeln, ',
    team_text2: 'die echten Mehrwert für Ihr Unternehmen schafft.',
    customers: 'Wer vertraut auf Blue Alps',
    customers_title_prefix: 'Wer',
    customers_title_accent: 'vertraut',
    customers_title_suffix: 'auf Blue Alps',
  },
  projects: {
    title: 'Projekte mit Impact',
    subtitle:
      'Innovative Lösungen, die eine effizientere und nachhaltigere Zukunft gestalten.',
    view_details: 'Details ansehen',
    items: [
      {
        id: 'divina',
        category: 'E-Commerce',
        title: 'Divina E-Commerce',
        description:
          'Eine Schweizer E-Commerce-Plattform für Bett-, Bad- und Tischwäsche. Eine mehrsprachige, responsive Website mit Fokus auf Usability, Produktvarianten, individuellem Checkout und Integrationen in lokale Systeme.',
      },
      {
        id: 'farol',
        category: 'SEO',
        title: 'Farol SEO',
        description:
          'Eine automatisierte SEO-Audit-Plattform, die komplette Websites analysiert und klare, umsetzbare Reports zu SEO, Performance und Barrierefreiheit liefert – ideal zur Verbesserung Ihrer digitalen Präsenz.',
      },
      {
        id: 'gallery',
        category: 'Admin-System',
        title: 'Gallery',
        description:
          'Galerie Gleis 4 entwickelte eine Kommunikations-App zum Versand von Massen-E-Mails an Kundinnen und Kunden. Eine Gästeliste aus einer Tabelle ermöglicht schnelle, effiziente Einladungskampagnen.',
      },
      {
        id: 'muller',
        category: 'WordPress',
        title: 'Projekt Müller',
        description:
          'Migration von einem proprietären CMS ohne wesentliche Wartung seit über 10 Jahren zu WordPress, inklusive technischer Modernisierung, Einhaltung Schweizer Rechtsanforderungen, vertrauter Administrationsoberfläche, strukturierter Inhalte und integriertem PDF-Handbuch. Kundenfeedback: Ich habe geschätzt, dass ihr, als es ums Aufschalten ging, wirklich schnell auf Rückfragen reagiert habt – auch als die Seite dann schon online war.',
      },
      {
        id: '1001',
        category: 'Wartung',
        title: 'Projekt 1001',
        description:
          'Fortgeschrittenes Praktikumsprojekt mit Fokus auf korrektive und evolutionäre Wartung, einschließlich der Aktualisierung der MongoDB-Integration, um eine veraltete Version zu ersetzen und Kompatibilität, Sicherheit und Betriebskontinuität zu stärken.',
      },
      {
        id: 'HausHeld',

        category: 'SEO und KI',

        title: 'HausHeld',

        description:
          'Optimierung der digitalen Präsenz mit SEO-Strategien zur Verbesserung von Performance, Sichtbarkeit in Suchmaschinen und organischem Traffic sowie eine KI-basierte Lösung für eine effizientere und intuitivere Navigation.',
      },
    ],
  },
  contact: {
    title: 'Kontakt',
    subtitle: 'Sprich direkt mit BlueAlps auf WhatsApp.',
    direct_contact_note: 'Wir kontaktieren Sie direkt aus Brasilien.',
    cta: 'Chatten',
    cta_email: 'E-Mail senden',
    cta_booking: 'Termin buchen',
    whatsapp_label: 'BlueAlps WhatsApp',
    email_label: 'BlueAlps E-Mail',
    booking_label: 'Meeting buchen',
    booking_hint: 'Wählen Sie kostenlos einen Termin über Microsoft Bookings',
    roles: {
      support: 'Kundenservice',
      commercial: 'Vertrieb',
    },
    messages: {
      general: 'Hallo! Ich möchte mit BlueAlps sprechen.',
      emanuele: 'Hallo! Ich möchte mit Emanuele sprechen.',
      commercial: 'Hallo! Ich möchte mit dem Vertrieb sprechen.',
    },
  },
  responsibleEntity: {
    title: 'Verantwortliche Stelle',
    address:
      'Hefti Engineering GmbH\nPestalozzistrasse 11\n9400 Rorschach\nSchweiz',
    email: 'E-Mail:',
  },
  authorizedPersons: {
    title: 'Vertretungsberechtigte Personen',
    name: 'Daniel Hefti',
  },
  company: {
    title: 'Name des Unternehmens',
    name: 'Hefti Engineering GmbH',
  },
  registration: {
    title: 'Registrierungsnummer',
    number: 'CHE-309.856.701',
  },
  disclaimer: {
    title: 'Haftungsausschluss',
    p1: 'Der Autor übernimmt keine Gewähr für Richtigkeit, Genauigkeit und Vollständigkeit der Inhalte.',
    p2: 'Alle Angebote sind unverbindlich. Änderungen bleiben vorbehalten.',
  },
  linksDisclaimer: {
    title: 'Haftungsausschluss für externe Links',
    p1: 'Für Inhalte externer Webseiten übernehmen wir keine Verantwortung.',
  },
  copyright: {
    title: 'Urheberrecht',
    p1: 'Alle Inhalte dieser Website unterliegen dem Urheberrecht der Hefti Engineering GmbH.',
  },
  source: 'Quelle: BrainBox Solutions',
};
